import React, {
  FC, useEffect, useState,
} from 'react';
import {
  RowCenter,
  Button,
} from './Styles';
import Header from '../../../../Common/Header';
import { Cab, ParcelUser, ParcelUserName } from '../../../../../../lib/types';
import { getFoodifoxDataLazy, updateFoodifoxData } from '../../../../../../lib/axios/FoodifoxDataAPI';
import { getCabId32Str, isEmailValid, isEmpty, isMobile, isNotEmpty } from '../../../../../../lib/utils/utils';
import UserName from './UserName';
import Email from './Email';
import RoomNo from './RoomNo';
import Terms from './Terms';
import PingFangRegularText from '../../../../../../components/Text/PingFangRegularText';
import ColumnCenter from '../../../../../../components/Layout/ColumnCenter';
import InterRegularText from '../../../../../../components/Text/InterRegularText';
import InterMediumText from '../../../../../../components/Text/InterMediumText';
import PingFangSemiBoldText from '../../../../../../components/Text/PingFangSemiBoldText';
import InterItalicText from '../../../../../../components/Text/InterItalicText';
import InterMediumItalicText from '../../../../../../components/Text/InterMediumItalicText';
import TermsConditionsModal from '../../../../Common/TermsConditionsModal';
import Column from '../../../../../../components/Layout/Column';
import Building from './Building/Building';

const SubmitForm: FC<Props> = ({
  onClose,
  isEnglish,
  setIsEnglish,
  cab,
  setShowLoading,
  setRegisterSuccess,
  phoneNumber,
  setUserId,
  setOrderIdList,
  setCabOrderBoxMap,
  registerUserInfo,
  setRegisterUserInfo,
}) => {
  const [getUserInfo, { loading: getUserInfoLoading }] = getFoodifoxDataLazy<ParcelUser>('/fox3PDUser/getUserInfo');
  const [createUserInfo, { loading }] = updateFoodifoxData<{ orderIdList: number[], userId: number, cabOrderBoxMap: { [key: number]: { boxCount: number; orderBoxList: string[] } } }>('/fox3PDUser/createUserInfo');
  const [checkbox1, setCheckbox1] = useState<boolean>(false);
  // 全名
  const [fullName, setFullName] = useState<string>('');
  // 领取外卖的姓名
  const [userNameList, setUserNameList] = useState<string[]>(['', '']);
  // 领取快递的姓名
  const [expressNameList, setExpressNameList] = useState<string[]>(['', '']);
  const [email, setEmail] = useState<string>();
  const [roomNo, setRoomNo] = useState<string>();
  const [buildingId, setBuildingId] = useState<number>();
  const [formError, setFormError] = useState<boolean>(false);
  //步骤
  const [step, setStep] = useState<number>(1);
  const [showTermsModal, setShowTermsModal] = useState<boolean>(false);

  useEffect(() => {
    // 滑动到顶部
    document.body.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [step]);

  useEffect(() => {
    setShowLoading(loading || getUserInfoLoading);

    return () => {
      setShowLoading(false);
    };
  }, [loading, getUserInfoLoading]);

  useEffect(() => {
    if (registerUserInfo) {
      // 全名
      setFullName(registerUserInfo.fullName || '');
      // 外卖姓名列表
      const userNameList = registerUserInfo.userNameList?.filter(({ platform }) => {
        return platform === 'h5' || platform == null;
      }).map(({ userName }) => {
        return userName || '';
      }) || [];
      if (userNameList.length === 0) {
        userNameList.push('', '');
      }
      else {
        userNameList.push('');
      }
      setUserNameList([...userNameList]);

      // 快递姓名列表
      const expressUserNameList = registerUserInfo.userNameList?.filter(({ platform }) => {
        return platform === 'parcel';
      }).map(({ userName }) => {
        return userName || '';
      }) || [];
      if (expressUserNameList.length === 0) {
        expressUserNameList.push('', '');
      }
      else {
        expressUserNameList.push('');
      }
      setExpressNameList([...expressUserNameList]);

      setEmail(registerUserInfo.email);
      setRoomNo(registerUserInfo.roomNo);
      setBuildingId(registerUserInfo.buildingId);
    }
    else {
      getUserInfo({
        param: {
          phoneNumber,
          registerCabId: cab.cabId,
        },
        onError() {
          setShowLoading(false);
        },
        onCompleted(userData) {
          if (userData) {
            // 全名
            setFullName(userData.fullName || '');
            // 外卖姓名列表
            const userNameList = userData.userNameList?.filter(({ platform }) => {
              return platform === 'h5' || platform == null;
            }).map(({ userName }) => {
              return userName || '';
            }) || [];
            if (userNameList.length === 0) {
              userNameList.push('', '');
            }
            else {
              userNameList.push('');
            }
            setUserNameList([...userNameList]);

            // 快递姓名列表
            const expressUserNameList = userData.userNameList?.filter(({ platform }) => {
              return platform === 'parcel';
            }).map(({ userName }) => {
              return userName || '';
            }) || [];
            if (expressUserNameList.length === 0) {
              expressUserNameList.push('', '');
            }
            else {
              expressUserNameList.push('');
            }
            setExpressNameList([...expressUserNameList]);

            setEmail(userData.email);
            setRoomNo(userData.roomNo);
            setBuildingId(userData.buildingId);
          }
          setShowLoading(false);
        },
      });
    }
  }, [registerUserInfo]);

  /**
   * 注册用户
   */
  const registerUser = () => {
    let isValid = true;
    if (userNameList.filter((userName) => isNotEmpty(userName)).length === 0) {
      isValid = false;
    }
    userNameList.filter((userName) => isNotEmpty(userName)).map((userName) => {
      if (isEmpty(userName)) {
        isValid = false;
      }
    });
    if (expressNameList.filter((userName) => isNotEmpty(userName)).length === 0) {
      isValid = false;
    }
    expressNameList.filter((userName) => isNotEmpty(userName)).map((userName) => {
      if (isEmpty(userName)) {
        isValid = false;
      }
    });
    if (isNotEmpty(email) && !isEmailValid(email)) {
      isValid = false;
    }
    if (isEmpty(fullName)) {
      isValid = false;
    }
    if (isEmpty(roomNo)) {
      isValid = false;
    }
    if (!checkbox1) {
      isValid = false;
    }
    //只有要选择建筑时才判断是否有选择建筑
    if (cab.buildingList && cab.buildingList.length > 0 && !buildingId) {
      isValid = false;
    }
    if (!isValid) {
      setFormError(true);
      return;
    }
    setFormError(false);

    createUserInfo({
      param: {
        phoneNumber,
        email,
        fullName,
        registerCabId: cab.cabId,
        registerAddress: cab.cabName,
        buildingId,
        roomNo,
        checkedTerms: 'Y',
        checkedSign: 'Y',
        userNameList: [
          ...userNameList.filter((userName) => isNotEmpty(userName)).map((userName) => {
            return { userName, platform: 'h5' };
          }),
          ...expressNameList.filter((userName) => isNotEmpty(userName)).map((userName) => {
            return { userName, platform: 'parcel' };
          }),
        ],
      },
      onCompleted({ orderIdList, userId, cabOrderBoxMap }) {
        setOrderIdList(orderIdList || []);
        setUserId(userId);
        setCabOrderBoxMap(cabOrderBoxMap || {});
        setRegisterSuccess(true);
        // 设置注册成功后的用户信息，用于其他组件使用
        setRegisterUserInfo({
          fullName,
          userId,
          phoneNumber,
          userNameList: [
            ...userNameList.filter((userName) => isNotEmpty(userName)).map((userName) => {
              return { userName, platform: 'h5' };
            }),
            ...expressNameList.filter((userName) => isNotEmpty(userName)).map((userName) => {
              return { userName, platform: 'parcel' };
            }),
          ] as ParcelUserName[],
          roomNo,
          email,
          buildingId,
        });
      },
    });
  };

  return (
    <>
      {
        showTermsModal && (
          <TermsConditionsModal
            callback={() => {
              setShowTermsModal(false);
            }}
            showAgreeBtn={false}
            showExitBtn={false}
            isEnglish={isEnglish}
          />
        )
      }
      <Column style={{ alignItems: isMobile() ? undefined : 'center' }}>
        <div style={{ width: isMobile() ? undefined : 400 }}>
          {/* 头部 */}
          <Header
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            style={{ marginTop: '20px' }}
            supportIsOnlyCall={true}
            cabId32Str={getCabId32Str(cab.cabId)}
            onClose={step === 1 ? onClose : () => {
              setStep(1);
            }}
          />

          <ColumnCenter style={{ marginTop: 30 }}>
            {
              step === 1 && (
                isEnglish ? (
                  <InterRegularText fontSize={16} lineHeight={22} opacity={0.5} textAlign={'center'} wordNewline={true}>
                    To deliver & notify you when your delivery<br />arrives, we need your delivery name.
                  </InterRegularText>
                ) : (
                  <PingFangRegularText lineHeight={20} opacity={0.6} textAlign={'center'}>
                    配送员会根据您填写的姓名来匹配物品。请您确<br />保填写所有您的外卖或快递可能会使用的收件人姓名。
                  </PingFangRegularText>
                )
              )
            }
            {
              step === 2 && (
                isEnglish ? (
                  <InterRegularText fontSize={16} lineHeight={22} opacity={0.5} textAlign={'center'} wordNewline={true}>
                    To make a delivery, we need your<br />Unit/Apartment number.
                  </InterRegularText>
                ) : (
                  <PingFangRegularText lineHeight={20} opacity={0.6} textAlign={'center'}>
                    为了方便您的配送，我们需要您的<br />公寓/门牌号。
                  </PingFangRegularText>
                )
              )
            }
          </ColumnCenter>

          {
            step === 1 && (
              <>
                {/* 姓名 */}
                <UserName
                  isEnglish={isEnglish}
                  formError={formError}
                  fullName={fullName}
                  setFullName={setFullName}
                  userNameList={userNameList}
                  setUserNameList={setUserNameList}
                  expressNameList={expressNameList}
                  setExpressNameList={setExpressNameList}
                />
                {/* 下一步 */}
                <RowCenter style={{ marginTop: 39 }}>
                  <Button
                    style={{ height: 60, background: (userNameList.filter((name) => !!name).length === 0 || expressNameList.filter((name) => !!name).length === 0 || isEmpty(fullName)) ? '#E4E4E4' : '#00D2B9', border: 'none', borderRadius: 5, width: '70%' }}
                    onClick={() => {
                      if (userNameList.filter((name) => !!name).length === 0 || expressNameList.filter((name) => !!name).length === 0 || isEmpty(fullName)) {
                        setFormError(true);
                        return;
                      }
                      setFormError(false);
                      setStep(2);
                    }}
                  >
                    {
                      isEnglish ? (
                        <InterMediumText fontSize={18} color={'#FFFFFF'}>
                          Continue
                        </InterMediumText>
                      ) : (
                        <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
                          下一步
                        </PingFangSemiBoldText>
                      )
                    }
                  </Button>
                </RowCenter>

                {
                  formError && (userNameList.filter((name) => !!name).length === 0 || expressNameList.filter((name) => !!name).length === 0 || isEmpty(fullName)) && (
                    <RowCenter style={{ marginTop: 10 }}>
                      <InterItalicText fontSize={12} lineHeight={15} textAlign={'center'} width={250} color={'#F44336'} wordNewline={true}>
                        {
                          userNameList.filter((name) => !!name).length === 0 && expressNameList.filter((name) => !!name).length === 0 ? (
                            isEnglish ? 'You must input at least 1 name for both Food & Parcel delivery' : '您必须至少输入一个姓名用于外卖和快递配送'
                          ) : (
                            userNameList.filter((name) => !!name).length === 0 ? (
                              isEnglish ? 'You must input at least 1 name for Food Delivery' : '您必须至少输入一个姓名用于外卖配送'
                            ) : (
                              expressNameList.filter((name) => !!name).length === 0 ? (
                                isEnglish ? 'You must input at least 1 name for Parcel Delivery' : '您必须至少输入一个姓名用于快递配送'
                              ) : (
                                isEmpty(fullName) ? (
                                  isEnglish ? 'You must input you full name' : '您必须输入您的全名'
                                ) : (
                                  ''
                                )
                              )
                            )
                          )
                        }
                      </InterItalicText>
                    </RowCenter>
                  )
                }
              </>
            )
          }
          {
            step === 2 && (
              <>
                {/* 选择建筑物 */}
                {
                  cab.buildingList && cab.buildingList.length > 0 && (
                    <Building
                      isEnglish={isEnglish}
                      formError={formError}
                      buildingList={cab.buildingList}
                      buildingId={buildingId}
                      setBuildingId={setBuildingId}
                    />
                  )
                }

                {/* 房间号 */}
                <RoomNo
                  isEnglish={isEnglish}
                  formError={formError}
                  roomNo={roomNo}
                  setRoomNo={setRoomNo}
                  buildingList={cab.buildingList}
                />

                {/* 电子邮箱 */}
                <Email
                  isEnglish={isEnglish}
                  formError={formError}
                  email={email}
                  setEmail={setEmail}
                />

                {/* 协议1 */}
                <Terms
                  isEnglish={isEnglish}
                  formError={formError}
                  checkbox={checkbox1}
                  setCheckbox={setCheckbox1}
                />

                {/* 注册按钮 */}
                <RowCenter style={{ marginTop: 39 }}>
                  <Button
                    style={{ height: 60, background: (!checkbox1 || !roomNo || (cab.buildingList && cab.buildingList.length > 0 && !buildingId)) ? '#E4E4E4' : '#00D2B9', border: 'none', borderRadius: 5, width: '70%' }}
                    onClick={() => {
                      registerUser();
                    }}
                  >
                    {
                      isEnglish ? (
                        <InterMediumText fontSize={18} color={'#FFFFFF'}>
                          Complete
                        </InterMediumText>
                      ) : (
                        <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
                          完成
                        </PingFangSemiBoldText>
                      )
                    }
                  </Button>
                </RowCenter>

                {
                  formError && (isEmpty(roomNo) || !checkbox1) && (
                    <RowCenter style={{ marginTop: 10 }}>
                      <InterItalicText fontSize={12} lineHeight={15} textAlign={'center'} width={250} color={'#F44336'} wordNewline={true}>
                        {
                          isEmpty(roomNo) ? (
                            isEnglish ? 'Unit/Apartment number is required' : '您必须输入您的公寓/门牌号'
                          ) : (
                            !checkbox1 ? (
                              isEnglish ? 'Agree to Terms of use and Privacy Policy' : '您必须同意我们的服务条款和隐私政策'
                            ) : (
                              ''
                            )
                          )
                        }
                      </InterItalicText>
                    </RowCenter>
                  )
                }
              </>
            )
          }

          <div style={{ height: 80, width: '100%' }} />

          <RowCenter style={{ position: 'fixed', bottom: 0, paddingBottom: 10, paddingTop: 5, width: '100%', backgroundColor: '#FFFFFF' }}>
            <Button onClick={() => setShowTermsModal(true)}>
              <InterMediumItalicText fontSize={12} textDecorationLine={'underline'}>
                Terms of use and Privacy Policy
              </InterMediumItalicText>
            </Button>
          </RowCenter>
        </div>
      </Column>
    </>
  );
};

export interface Props {
  onClose: () => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  cab: Cab;
  setShowLoading: (isShow: boolean) => void;
  setRegisterSuccess: (isSuccess: boolean) => void;
  phoneNumber: number;
  setOrderIdList: (idList: number[]) => void;
  setUserId: (userId: number) => void;
  setCabOrderBoxMap: (map: { [key: number]: { boxCount: number; orderBoxList: string[] } }) => void;
  registerUserInfo?: ParcelUser;
  setRegisterUserInfo: (user: ParcelUser) => void;
}

export default SubmitForm;
